import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { ArrowUp } from 'lucide-react';

export const BackToTop = () => {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      data-testid="back-to-top-btn"
      className={`fixed bottom-24 right-24 z-[9998] p-3 rounded-full shadow-lg transition-all duration-300 ease-out group ${
        isVisible 
          ? 'opacity-100 translate-y-0 pointer-events-auto' 
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      style={{ 
        background: 'linear-gradient(135deg, #464B8B 0%, #00C8EB 100%)',
        boxShadow: '0 4px 20px rgba(0, 200, 235, 0.3)'
      }}
      aria-label="Back to top"
    >
      <ArrowUp 
        className="w-5 h-5 text-white transition-transform duration-200 group-hover:-translate-y-1" 
      />
      
      {/* Pulse ring effect */}
      <span 
        className={`absolute inset-0 rounded-full animate-ping opacity-20`}
        style={{ background: 'linear-gradient(135deg, #464B8B 0%, #00C8EB 100%)' }}
      />
    </button>
  );
};
